import common from '../../global/common'

let userData = common.getUserInfo()
let CityInfo = common.getCityInfo()
let personInfo = common.getUserSimpleInfo()
let personImg = common.getUserImg()
let mName = common.getName()
let token = common.getCookie('qd_access_token')
let benzhan = window.location.hostname.split('.')[0]
let qdsite = 2
if (benzhan === 'localhost' || benzhan === '10' || benzhan === 'uat' || benzhan === 'chindle') {
  qdsite = 1
} else if (benzhan === 'saas') {
  qdsite = 2
} else {
  qdsite = 3
}
const state = {
  userInfo: userData || {},
  // hideUnreadNotice: Boolean(localStorage.getItem(userData.userId + '_hideUnreadNotice')),
  // hideUnreadMsg: Boolean(localStorage.getItem(userData.userId + '_hideUnreadMsg')),
  // 是否登录
  sign: !!token,
  // 用户名
  name: mName,
  // 登录使用的token
  token: token,
  // 信息数量
  count: '',
  siteMsg: '',
  feedbackMsg: '',
  // 头像
  userImg: personImg,
  // 是否是第一次登录 0 不是首次登录 1首次登录
  firstLogin: userData.firstLogin,
  // 是否显示赠课领取弹窗
  isShow: userData.isShow,
  // 用户类型
  userType: userData.userType,
  // 用户id
  userId: userData.userId,
  // 用户是否是说课用户
  talkUser: personInfo,
  backgroundColor: userData.backgroundColor,
  // 用户是否需要审核
  isAudit: '',
  returnCityInfo: CityInfo,
  grade: [],
  menuList: '',
  isQd: qdsite,
  companyId: '',
  branchName: '',
  isMember: personInfo.isMember,
  memberTime: personInfo.isShowHiddenBillDetails,
  courseItem: {},
  companyInfo: {}
}

const mutations = {
  changeCompanyInfo (state, data) {
    state.companyInfo = data
  },
  changeFirstLogin (state, firstLogin) {
    state.firstLogin = firstLogin
    common.setFirstLogin(firstLogin)
  },
  login (state, userInfo) {
    common.setUserInfo(userInfo)
    state.userInfo = userInfo
    state.sign = true
    state.name = userInfo.userName
    state.backgroundColor = userInfo.backgroundColor
    state.talkUser = userInfo.talkUser
    state.token = userInfo.token
    state.isShow = userInfo.isShow
    state.userType = userInfo.userType
    state.userId = userInfo.userId
    state.isAudit = userInfo.isPerfect
    state.branchName = userInfo.branchName
    state.firstLogin = userInfo.firstLogin
  },
  logout (state) {
    if (window.noticeNotifyObj) {
      window.noticeNotifyObj.close()
      window.noticeNotifyObj = null
    }
    if (window.msgNotifyObj) {
      window.msgNotifyObj.close()
      window.msgNotifyObj = null
    }
    localStorage.removeItem('menu')
    common.clearUserInfo()
    state.sign = false
    state.name = ''
    state.token = ''
    state.userImg = ''
    state.talkUser = ''
    state.isMember = ''
    state.memberTime = ''
    state.firstLogin = 0
    state.isShow = ''
    state.userType = ''
    state.userId = ''
    state.isAudit = ''
    state.branchName = ''
    state.grade = []
  },
  changeCount (state, count) {
    state.count = count.count
    state.siteMsg = count.siteMsg
    state.feedbackMsg = count.feedbackMsg
  },
  changeUserInfo (state, userInfo) {
    common.setUserImg(userInfo.info.imgUrl)
    common.setName(userInfo.info.userName)
    state.name = userInfo.info.userName
    state.userImg = userInfo.info.imgUrl
  },
  changeTalkUser (state, talkInfo) {
    common.setPerInfo(talkInfo)
    state.talkUser = talkInfo.talkUser
    state.isMember = talkInfo.info.isMember
    state.memberTime = talkInfo.info.isShowHiddenBillDetails
  },
  changeCourse (state, courseInfo) {
    console.log(courseInfo)
    state.courseItem = courseInfo
  }
}

const actions = {
  login: ({commit}, userInfo) => {
    commit('login', userInfo)
  },
  logout: ({commit}) => {
    commit('logout')
  },
  changeCount: ({ commit }, count) => {
    commit('changeCount', count)
  },
  // changeFirstLogin: ({ commit }, login) => {
  //   commit('changeFirstLogin', login)
  // },
  changeUserInfo: ({ commit }, userInfo) => {
    commit('changeUserInfo', userInfo)
  },
  changeTalkUser: ({ commit }, talkInfo) => {
    commit('changeTalkUser', talkInfo)
  },
  changeCourse: ({ commit }, courseInfo) => {
    commit('changeCourse', courseInfo)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth-user.js